import Vue from "vue";
import Vuex from "vuex";
import metafields from "../store/metafields";
import product from "../store/product";

const createStore = () => {
  Vue.use(Vuex);
  return new Vuex.Store({
    strict: process.env.NODE_ENV !== "production",
    modules: {
      metafields,
      product,
    },
  });
};

export const store = createStore();
